import React, { Component } from "react";
import { Checkbox } from 'antd';

const CheckboxGroup = Checkbox.Group;

const plainOptions = ["ArtworkType", "ProofLink", "XandrNative", "XandrWallpaper"];
const defaultCheckedList = ["ArtworkType", "ProofLink", "XandrNative", "XandrWallpaper"];

class TogglePanelsComponent extends React.Component {
  state = {
    checkedList: defaultCheckedList,
    indeterminate: true,
    checkAll: false,
  };

  onChange = checkedList => {
    this.setState({
      checkedList,
      indeterminate: !!checkedList.length && checkedList.length < plainOptions.length,
      checkAll: checkedList.length === plainOptions.length,
    } , () => this.props.togglePanels(checkedList));

  };

  onCheckAllChange = e => {
    this.setState({
      checkedList: e.target.checked ? plainOptions : [],
      indeterminate: false,
      checkAll: e.target.checked,
    } , () => this.props.togglePanels(e.target.checked ? plainOptions : []));
  };

  render() {
    return (
      <div style={{background: '#fff' , padding: '15px' , marginBottom: '15px'}}>
        <div style={{ borderBottom: '1px solid #E9E9E9' }}>
          <Checkbox
            indeterminate={this.state.indeterminate}
            onChange={this.onCheckAllChange}
            checked={this.state.checkAll}
          >
            Toggle Panels
          </Checkbox>
        </div>
        <br />
        <CheckboxGroup
          options={plainOptions}
          value={this.state.checkedList}
          onChange={this.onChange}
        />
      </div>
    );
  }
}
export default TogglePanelsComponent;



// WEBPACK FOOTER //
// ./src/components/Dashboard/TogglePanels/TogglePanelsComponent.js